<template>
  <div
    class="c-outreach-contact-connect"
    data-testid="outreach-contact-connect-twitter"
  >
    <QSpinner
      v-if="loading"
      :size="30"
    />
    <div
      v-else
      class="c-outreach-contact-connect-twitter__content"
    >
      <div class="c-outreach-contact-connect-twitter__content-header">
        {{ $t("outreach_contact_connect_twitter.integrate_heading") }}
      </div>
      <div class="c-outreach-contact-connect-twitter__content-body">
        <i18n-t
          keypath="outreach_contact_connect_twitter.integrate_body"
          scope="global"
        >
          <template #newline>
            <br />
          </template>
        </i18n-t>
      </div>
      <BaseButton
        color="primary"
        icon="img:https://assets.streem.com.au/icons/engage/50x50_twitter.svg"
        :label="$t('outreach_contact_connect_twitter.connect_label')"
        new-design
        to="/outreach/organisation/integrations"
      />
    </div>
  </div>
</template>

<script>
import { BaseButton } from "shared/components/base";
import TwitterSocialIntegration from "shared/resources/TwitterSocialIntegration";

export default {
  name: "OutreachContactConnectTwitter",
  components: { BaseButton },
  emits: ["set-social-integration-id"],
  data() {
    return {
      loading: false,
      twitterIntegrations: [],
    };
  },
  computed: {
    anyExpiredIntegrations() {
      return this.twitterIntegrations.some((integration) =>
        this.isExpired(integration)
      );
    },
  },
  mounted() {
    this.loadTwitterIntegrations();
  },
  methods: {
    async loadTwitterIntegrations() {
      try {
        this.loading = true;

        this.twitterIntegrations = (
          await TwitterSocialIntegration.where({
            archivedAt: { eq: "null" },
            isOutreachAccount: { eq: true },
          })
            .order({ expiredAt: "desc" })
            .all()
        ).data;

        if (this.twitterIntegrations.length && !this.anyExpiredIntegrations) {
          this.$emit(
            "set-social-integration-id",
            this.twitterIntegrations[0].id
          );
        }
      } catch (error) {
        this.$error(
          this.$t("outreach_contact_connect_twitter.load_integration_error"),
          error
        );
      } finally {
        this.loading = false;
      }
    },
    isExpired(option) {
      return option.expiredAt && new Date(option.expiredAt) <= new Date();
    },
  },
};
</script>

<style scoped lang="scss">
.c-outreach-contact-connect-twitter {
  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;

    &-header {
      font-size: 20px;
      font-weight: 700;
    }

    &-body {
      text-align: center;
      font-size: 14px;
      padding-bottom: 27px;
    }
  }
}
</style>
